import { BarChart, GaugeChart, LineChart, MapChart, PieChart } from 'echarts/charts';
import {
  GridComponent,
  LegendComponent,
  TitleComponent,
  TooltipComponent,
  VisualMapComponent,
} from 'echarts/components';
import * as echarts from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';

echarts.use([
  BarChart,
  LineChart,
  MapChart,
  GaugeChart,
  PieChart,
  GridComponent,
  TooltipComponent,
  LegendComponent,
  VisualMapComponent,
  TitleComponent,
  CanvasRenderer,
]);

let mapPromise: Promise<void> | null = null;

/**
 * Lazily loads the ~1MB world GeoJSON (as a separate chunk, so non-map cards
 * never pay for it) and registers the 'world' map exactly once. Await this
 * before rendering a map chart, so the map is registered before the first
 * setOption runs.
 */
export const ensureWorldMap = (): Promise<void> => {
  if (!mapPromise) {
    mapPromise = import('./world.geo.json').then((mod) => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      echarts.registerMap('world', ((mod as { default?: unknown }).default ?? mod) as any);
    });
  }
  return mapPromise;
};

export { echarts };
